
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SharedService } from "./../shared/shared.service";
import { DevoteeDetail } from "./devotee-detail";
import { Serialkey } from './serialkey/serialkey';
import { VarifyOTPResponse } from '../shared/varify-otp-response';

@Injectable()
export class DevoteeService {

  constructor(private _http: HttpClient) { }

  ServiceUrl: string = SharedService.BaseServiceUrl + "User";

  DevoteeMobileNo: string;

  public saveDevotee(devoteeDetail: DevoteeDetail): Observable<string> {
    return this._http.post<string>(this.ServiceUrl, devoteeDetail)
  }

  public getDevotee(): Observable<DevoteeDetail[]> {
    return this._http.get<DevoteeDetail[]>(this.ServiceUrl);
  }

  public getEntity(id: number): Observable<DevoteeDetail> {

    let paramData = new HttpParams().set("id", id.toString());
    return this._http.get<DevoteeDetail>(this.ServiceUrl, { params: paramData })
  }

  public getByMobileNo(mobileNo: string): Observable<DevoteeDetail> {
    let getbyMobileUrl = this.ServiceUrl + "/GetByMobileNo/" + mobileNo;
    return this._http.get<DevoteeDetail>(getbyMobileUrl);
  }

  public getByLogin(mobileNo: string): Observable<DevoteeDetail> {
    let getbyMobileUrl = this.ServiceUrl + "/GetByLogin/" + mobileNo;
    return this._http.get<DevoteeDetail>(getbyMobileUrl);
  }

  public updateDevotee(devoteeDetail: DevoteeDetail): Observable<string> {
    let putUrl = this.ServiceUrl + "/Update/Profile/";
    return this._http.post<string>(putUrl, devoteeDetail);
  }

  public getUserProfile(): Observable<DevoteeDetail> {
    let getbyMobileUrl = this.ServiceUrl +  "/profile/";
    return this._http.get<DevoteeDetail>(getbyMobileUrl);
  }

  
  public sendOTP(mobileNo: string): Observable<string> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "Auth/request-otp";
    let request: any = {
      MobileNo: mobileNo.toString(),
      Platform: 'DevoteeWebApp'
    }
    return this._http.post<string>(getbyMobileUrl, request);
  }

  public varifyOTP(mobileNo: string, otp: string): Observable<VarifyOTPResponse> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "Auth/verify-otp";
    let request: any = {
      MobileNo: mobileNo.toString(),
      OTP: otp.toString(),
      DeviceId: 'DevoteeWebApp',
      Platform: 'DevoteeWebApp'
    }
    return this._http.post<VarifyOTPResponse>(getbyMobileUrl, request);
  }

 

  public GetLicenseKey(serialKey: Serialkey): Observable<Serialkey> {
    const url = SharedService.BaseServiceUrl + '/Serial/CreateSerialKey';
    return this._http.post<Serialkey>(url, serialKey);
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee.service.ts